// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { Checkboxes, FileInputMateDrive, TabPanel } from "../../../FlowConfigurationInputs";
import { CheckIfFlowUpdated } from "../../../../helpers/helper";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { changedFields, initialActions, saveAvailable } from "../../../../recoil-store/recoil-state";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Emirhan Bilal Yeşil
 */
function Decode({ action, showAlert, variables, setOpenVariable, automId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.BASE64.';
    const [value, setValue] = useState(0);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const options = {
        checkboxes: { label: label + "OVERWRITE" },
    };

    useEffect(() => {
        if (action.fields.fieldType?.value === "CS") {
            setValue(2);
        } else {
            setValue(1)
        }
    }, [action, variables])

    function base64BackupSetup() {
        const tmpBase64Value = action.fields.base64Code.value
        if (action.fields.base64Code.backup) {
            action.fields.base64Code.value = action.fields.base64Code.backup.value
        }
        action.fields.base64Code.backup = { value: tmpBase64Value }
    }

    function handleChangeTabs(newValue) {
        // if the tab is File Path
        if (newValue === 1) {
            // base64BackupSetup();

            if (action.fields.backup?.fileName) {
                action.fields.fileName = { value: action.fields.backup.fileName.value }
                action.fields.folderPath = { value: action.fields.backup.folderPath.value }
                action.fields.overwrite = { value: action.fields.backup.overwrite.value }
            }

            action.fields.fieldType = { value: "FP" }
            // if the tab is Select File
        } else {
            // base64BackupSetup();
            if (action.fields.fileName.value) {
                action.fields.backup = {
                    fileName: { value: action.fields.fileName.value },
                    folderPath: { value: action.fields.folderPath.value },
                    overwrite: { value: action.fields.overwrite.value }
                }
            }
            delete action.fields.fileName
            delete action.fields.folderPath
            delete action.fields.overwrite
            action.fields.fieldType = { value: "CS" }
            if (!action.fields.base64Code?.value) {
                action.fields.base64Code = { value: "" }
            }
        }
        const field = initialActionsData[action.id]?.fields.fieldType;
        const oldValue = !field ? undefined : field.value;
        let v = newValue === 1 ? "FP" : "CS";
        CheckIfFlowUpdated("fieldType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
        setValue(newValue);
    }


    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DECODE.BASE64-CODE')} is_required />
                <TextInput action={action} inputName="base64Code" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" fieldType="string"
                    displayName={t(label + 'DECODE.BASE64-CODE')} hideRequired isRequired />
            </div>
            <div className="condition-tabs" style={{ marginBottom: 10 }}>
                <button
                    className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
                    onClick={() => handleChangeTabs(1)}>
                    {/* {t(label + 'ENCODE.FILE-PATH')} */}
                    {t(label + 'ENCODE.FILE-DECODING')}
                </button>
                <button
                    className={`f-s-11 ${value === 2 ? 'condition-active' : ''}`}
                    onClick={() => handleChangeTabs(2)}>
                    {/* {t(label + 'ENCODE.CUSTOM-STRING')} */}
                    {t(label + 'ENCODE.VALUE-DECODING')}
                </button>
            </div>
            <TabPanel value={value} index={1}>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'DECODE.FILE-NAME')} is_required />
                    <TextInput action={action} inputName="fileName" variables={variables}
                        setOpenVariable={setOpenVariable}
                        filter="string" fieldType="string"
                        displayName={t(label + 'DECODE.FILE-NAME')} hideRequired isRequired />
                    <small className="conf-field-desc"><em>{t(label + 'DECODE.FILE-NAME-DESC')}</em></small>
                </div>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "DECODE.FOLDER-PATH")} is_required />
                    <TextInput
                        action={action}
                        inputName="folderPath"
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        // extractPath="folder"
                        fieldType="string"
                        displayName={t(label + 'DECODE.FOLDER-PATH')}
                        hideRequired
                        isRequired
                        autom_id={automId}
                    />
                </div>
                <div className="conf-field-container">
                    <Checkboxes
                        action={action}
                        inputName="overwrite"
                        options={options.checkboxes}
                    />
                </div>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'DECODE.ASSIGN-FILE')} />
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable}
                        filter="string" />
                    <small
                        className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
                </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'DECODE.ASSIGN-VALUE')} />
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable}
                        filter="string" />
                    <small
                        className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
                </div>
            </TabPanel>

        </>
    );
}

export default Decode;